import { Image } from '@heroui/react';
import { FC } from 'react';

import AccesIcon from '../../assets/icons/access.svg';
import InfoIcon from '../../assets/images/no_data.png';
import {
  Button,
  ContentWrapper,
  Description,
  ErrorContainer,
  ErrorWrapper,
  Title,
} from './Error.styled';

interface OrgPageProps {
  errorTitle?: string;
  errorMessage?: string;
  action?: () => void;
  info?: boolean;
}
export const Error: FC<OrgPageProps> = ({ info, errorTitle, errorMessage, action }) => (
  <ErrorWrapper>
    <ErrorContainer>
      <ContentWrapper>
        <Image src={info ? InfoIcon : AccesIcon} alt="access denied" style={{ width: '80px', height: 'auto' }} />
        <Title>{errorTitle || 'Page Not found'}</Title>
        <Description>
          {errorMessage}
        </Description>
        {action && <Button type="button" onClick={action}>Try again</Button>}
      </ContentWrapper>
    </ErrorContainer>
  </ErrorWrapper>
);
